module.exports = __webpack_public_path__ + "img/Img32_214951_CeEt-950-3A23-1.fa9a1337.jpg";